const en = {
  nav: {
    start: "Home",
    about: "About me",
    topics: "Topics",
    methods: "My approach",
    pricing: "Fees",
    faq: "FAQ",
    feedback: "Feedback",
    contact: "Contact",
  },
  common: {
    whatsappCta: "Message on WhatsApp",
    whatsappCtaLong: "Free initial call via WhatsApp",
    whatsappAria: "Get in touch directly via WhatsApp",
    readMore: "Learn more",
    toTopic: "Go to topic",
    newBadge: "New",
    related: "Related topics",
    backToTopics: "All topics",
    backToMethods: "All methods",
    onlineBadge: "Also available online",
    rating: "4.8/5 · 32 Google reviews",
    skipToContent: "Skip to content",
    menu: "Menu",
    close: "Close",
    chapter: "Chapter",
  },
  wa: {
    message:
      "Hello Ms. Rafiq-Arli, I would like to request an appointment for a free initial consultation. Kind regards",
  },
  home: {
    overline: "Practice for Hypnosis & Psychotherapy · Hamburg-Alsterdorf",
    heroLines: ["Clarity.", "Healing.", "Inner freedom."],
    heroSub:
      "Hypnosis, psychotherapy and counselling – empathetic, culturally sensitive and solution-focused. In German and Turkish, in practice and online.",
    ctaPrimary: "Book a free initial call",
    ctaSecondary: "Explore topics",
    marquee: [
      "Trauma",
      "Anxiety & Phobias",
      "Depression",
      "Self-worth",
      "Weight",
      "Smoke-free",
      "Grief",
      "Burnout",
      "Exam anxiety",
      "Culturally sensitive therapy",
    ],
    manifesto: {
      overline: "My philosophy",
      title: "Three steps on a path we walk together",
      chapters: [
        {
          title: "Understand",
          text: "Every symptom has a story. In the free initial call, I listen – without judgement, at your pace, at eye level.",
        },
        {
          title: "Release",
          text: "With hypnosis, Havening and EFT we reach the causes where they live: in the subconscious. Gently, safely, evidence-based.",
        },
        {
          title: "Strengthen",
          text: "You leave every session with new inner resources – for a life with more calm, confidence and freedom.",
        },
      ],
    },
    topics: {
      overline: "How can I help?",
      title: "Topics & applications",
      sub: "From trauma to quitting smoking: find quick answers to what moves you.",
    },
    methods: {
      overline: "Integrative & individual",
      title: "My approach",
      sub: "Eight proven methods, one goal: lasting change. I combine what fits you.",
      cta: "View all methods",
    },
    about: {
      overline: "Your therapist",
      title: "Naciye Rafiq-Arli",
      text: "State-certified alternative practitioner for psychotherapy (Heilpraktikerin), born in Hamburg, mother of four. I support people holistically – empathetic, culturally sensitive and heartfelt.",
      facts: [
        "Heilpraktikerin for Psychotherapy",
        "German · Turkish",
        "Practice & online sessions",
      ],
      cta: "More about me",
    },
    testimonials: {
      overline: "Experiences",
      title: "What clients say",
      items: [
        {
          quote:
            "After just a few sessions I could feel great steps towards improvement and received a lot of positive feedback from the people around me.",
        },
        {
          quote:
            "I saw big changes after a short time and can recommend it to anyone struggling with trauma or anxiety disorders.",
        },
      ],
    },
    ctaBand: {
      title: "The first step costs nothing.",
      text: "Phone consultation (30 minutes) – free and without obligation. Just send me a message on WhatsApp.",
      button: "Start on WhatsApp now",
    },
    anfahrt: {
      overline: "Getting here",
      title: "How to find the practice",
      text: "Traute-Lafrenz-Straße 161 in Hamburg-Alsterdorf – easy to reach by bus and train. Parking is available nearby. Many sessions are also available online.",
      routeCta: "Plan route in Google Maps",
      mapTitle: "Map: Practice for Hypnosis & Psychotherapy, Traute-Lafrenz-Straße 161, Hamburg-Alsterdorf",
    },
    values: ["Empathetic", "Trustworthy", "Solution-focused", "Individual"],
    support: {
      overline: "Support",
      title: "How I can support you",
    },
    approach: {
      overline: "My therapeutic approach",
      title: "Modern methods for lasting change",
      rows: [
        { key: "hypnose", title: "Hypnosis", text: "Access to the subconscious to enable positive change." },
        { key: "eft", title: "EFT (Emotional Freedom Techniques)", text: "Tapping technique to release emotional blocks and stress." },
        { key: "havening", title: "Havening", text: "Gentle touch techniques to calm the nervous system." },
        { key: "gespraech", title: "Talk psychotherapy", text: "Understand, reflect and develop new perspectives." },
      ],
      cta: "More about my approach",
    },
  },
  topics: {
    pageOverline: "Applications",
    pageTitle: "Topics you can come to me with",
    pageSub:
      "Clearly explained, without jargon: what lies behind the topic and how we tackle it together.",
    items: {
      trauma: {
        badge: "New",
        title: "Understanding & resolving trauma",
        teaser:
          "Distressing experiences can echo for years. With gentle, effective methods we release what holds you back.",
        sections: [
          {
            h: "What is trauma?",
            paras: [
              "Trauma occurs when an experience was too overwhelming to process in the moment – such as an accident, a loss, violence or abuse. Body and soul then store what happened as if the danger were still present.",
              "Not every difficult experience becomes a trauma. What matters is how the nervous system assessed the event – and whether it could feel safe again afterwards.",
            ],
          },
          {
            h: "How can trauma affect you?",
            paras: [
              "Possible consequences include sleep problems, inner restlessness, nightmares, sudden anxiety, concentration difficulties or physical complaints without a clear cause. Many people avoid places, people or situations that remind them of what happened.",
              "Trauma often lies behind other issues: anxiety disorders, depression, emotional eating or low self-worth.",
            ],
          },
          {
            h: "How I treat trauma in my practice",
            paras: [
              "My central method is Havening – a psychosensory technique that soothes distressing memories through gentle touch and releases their emotional charge. I complement this with regressive hypnosis to find unconscious causes, EFT for gentle relief, and client-centred talk therapy as the supporting foundation.",
              "Important: you set the pace. Everything happens within a safe framework – and you remain in full control at all times.",
            ],
          },
          {
            h: "Good to know",
            paras: [
              "Hypnotherapy was recognised in 2006 by the German Scientific Advisory Board for Psychotherapy as an evidence-based method. Many clients feel noticeable relief after just a few sessions.",
            ],
          },
        ],
        related: ["angst", "depression", "selbstwert", "gewicht"],
      },
      angst: {
        title: "Overcoming anxiety disorders",
        teaser:
          "Anxiety is meant to protect us – sometimes it spirals out of control. With hypnosis and behavioural therapy we find the cause and resolve it.",
        sections: [
          {
            h: "What is an anxiety disorder?",
            paras: [
              "Anxiety is a natural protective mechanism. When it becomes too strong, appears without real cause or rules everyday life, we speak of an anxiety disorder – such as panic attacks, social anxiety or phobias.",
            ],
          },
          {
            h: "Causes & symptoms",
            paras: [
              "Common causes are traumatic childhood experiences, prolonged stress or unfavourable learning experiences. Anxiety shows physically – racing heart, sweating, trembling, shortness of breath – and mentally, for example as constant worry or avoidance.",
              "Left untreated, an anxiety disorder can develop into depression. That is why acting early matters.",
            ],
            list: [
              "Simple phobias: fear of animals, heights, needles and more",
              "Complex phobias: e.g. social phobia, agoraphobia",
              "Hidden phobias: anxiety appears indirectly, e.g. as physical complaints",
            ],
          },
          {
            h: "How I treat anxiety",
            paras: [
              "With regressive, uncovering short-term hypnotherapy we find the root of the anxiety – often in experiences long forgotten. Combined with cognitive behavioural therapy, the anxiety loses its ground.",
              "Usually a few sessions are enough for you to feel a noticeable change.",
            ],
          },
        ],
        related: ["trauma", "depression", "selbstwert"],
      },
      depression: {
        title: "Depression – ways back to life",
        teaser:
          "When joy fades and everything feels heavy: we find the hidden causes and reactivate your life energy.",
        sections: [
          {
            h: "Typical symptoms",
            paras: [
              "Depression shows through low mood, loss of interest, compulsive rumination, despondency, lack of drive, concentration problems and a deep exhaustion that even sleep does not heal.",
            ],
          },
          {
            h: "Where does depression come from?",
            paras: [
              "The causes often lie in the unconscious: prolonged stress, burnout, unresolved conflicts or an anxiety disorder can trigger depression. Often you do not know yourself how it came this far.",
            ],
          },
          {
            h: "My treatment",
            paras: [
              "With regressive hypnosis we uncover the unconscious triggers and resolve them at the root. Cognitive behavioural therapy additionally helps to change burdensome thought patterns step by step.",
            ],
          },
        ],
        related: ["angst", "trauma", "trauer"],
      },
      selbstwert: {
        title: "Strengthening self-worth",
        teaser:
          "Shyness, self-doubt, holding back: hypnosis releases unexpected resources and strengthens you from within.",
        sections: [
          {
            h: "How low self-worth shows itself",
            paras: [
              "It appears as shyness, insecurity, difficulty asserting yourself or the feeling of never being good enough – in private life as well as at work. It is one of the most common accompanying topics in my practice.",
            ],
          },
          {
            h: "Where does it come from?",
            paras: [
              "The roots often lie in childhood: critical voices, hurtful experiences or trauma shape the image we have of ourselves – until today.",
            ],
          },
          {
            h: "How hypnosis helps",
            paras: [
              "In trance we release old blocks and anchor new, strengthening beliefs with suggestion and affirmation directly in the subconscious. This builds self-worth that carries you – even in difficult situations.",
            ],
          },
        ],
        related: ["trauma", "angst", "depression"],
      },
      gewicht: {
        title: "Losing weight with hypnosis",
        teaser:
          "Diets fail in the mind. Hypnosis changes eating behaviour where it is controlled – in the subconscious.",
        sections: [
          {
            h: "Two paths – the one that fits you",
            paras: [
              "For mild overweight I work with suggestive hypnosis: new, healthy eating habits are anchored directly. For stronger overweight and emotional eating I use analytical hypnosis (hypnoanalysis) to resolve the deeper causes.",
            ],
          },
          {
            h: "Understanding emotional eating",
            paras: [
              "Food often becomes a substitute: it soothes anxieties, grief, trauma or relationship conflicts. As long as the emotional hunger remains, almost every diet fails. This is exactly where hypnoanalysis comes in.",
            ],
          },
          {
            h: "Scientifically proven",
            paras: [
              "Prof. Dirk Revenstorf of the University of Tübingen demonstrated in a study that hypnosis is sustainably effective for weight reduction – without the yo-yo effect.",
            ],
          },
        ],
        related: ["trauma", "selbstwert"],
      },
      rauchen: {
        title: "Quitting smoking",
        teaser:
          "Smoking is an unconscious conditioning. In a single intensive session we release it – sustainably smoke-free.",
        sections: [
          {
            h: "Why willpower alone is not enough",
            paras: [
              "Our habits live in the unconscious. That is why patches, apps and good resolutions fail so often: they do not reach the level where smoking is anchored.",
            ],
          },
          {
            h: "Smoke-free in one intensive session",
            paras: [
              "In a single session of about 2–4 hours we release the conditioning and anchor your new life as a non-smoker. The success rate of this method is high – many of my clients go home smoke-free and stay that way.",
              "The investment: €999 incl. VAT for the complete intensive programme.",
            ],
          },
        ],
        related: ["gewicht", "selbstwert"],
      },
      trauer: {
        title: "Processing grief & pastoral care",
        teaser:
          "Loss, farewells, difficult decisions: you do not have to go through this alone. Empathetic support – under confidentiality.",
        sections: [
          {
            h: "Pastoral accompaniment",
            paras: [
              "Grief needs space and time – and sometimes a person who can bear what is. I accompany you through experiences of loss, farewells, difficult decisions and deep disappointments.",
              "As a pastoral counsellor I am bound by confidentiality. Everything you entrust to me stays protected.",
            ],
          },
          {
            h: "Who is this for?",
            paras: [
              "For everyone who has lost a loved one, is facing a life decision or finds themselves in an existential crisis – regardless of religion or worldview.",
            ],
          },
        ],
        related: ["depression", "trauma"],
      },
      paartherapie: {
        title: "Couples Therapy & Marriage Counselling",
        teaser:
          "When conversations become hard and closeness fades: finding your way back into dialogue – structured and impartial.",
        sections: [
          {
            h: "When couples therapy helps",
            paras: [
              "Every relationship knows crises: recurring conflicts, conversations going in circles, breaches of trust or the feeling of having grown apart. Major changes – children, moving, career turns – present couples with new tasks.",
              "In couples therapy these topics get a protected space. Together we look at what lies behind the conflicts and what each side needs to feel seen again.",
            ],
          },
          {
            h: "How I work with couples",
            paras: [
              "I work in a client-centred and culturally sensitive way – both perspectives have equal space, without taking sides. In structured conversations we clarify patterns, expectations and unmet needs.",
              "When personal issues strain the relationship – such as old wounds or anxieties – I can additionally work individually with hypnosis, EFT or Havening. I also address cultural differences within the relationship with experience.",
            ],
          },
          {
            h: "Framework & costs",
            paras: [
              "Couples coaching and family coaching with children: 60 minutes, 390 € incl. VAT – also possible online. The first step is, as always, the free phone consultation (30 minutes).",
            ],
          },
        ],
        related: ["trauer", "selbstwert", "angst"],
      },
      beispiele: {
        title: "Treatment examples at a glance",
        teaser:
          "A look at the full range of my work – from A for anxiety to Z for achieving goals.",
        sections: [
          {
            h: "Further fields of application",
            paras: [
              "Beyond the focus topics I accompany you in many other areas. Just get in touch – in the free initial call we clarify which path is right for you.",
            ],
            list: [
              "Anxiety & panic disorders",
              "Burnout",
              "Depression",
              "Jealousy",
              "Relaxation",
              "Fear of flying",
              "Weight reduction",
              "Concentration",
              "Stage fright",
              "Phobias",
              "Procrastination",
              "Exam anxiety",
              "Smoking cessation",
              "Self-hypnosis",
              "Self-worth strengthening",
              "Sexual disorders",
              "Sports hypnosis",
              "Grief",
              "Fear of public speaking",
              "Achieving goals",
            ],
          },
        ],
        related: ["trauma", "angst", "rauchen"],
      },
    },
  },
  methods: {
    pageOverline: "My approach",
    pageTitle: "Eight methods, one goal: your change",
    pageSub:
      "I work integratively – combining proven procedures into a path that fits you.",
    items: {
      hypnose: {
        title: "Clinical Hypnosis",
        teaser:
          "The focus of my work: a natural state of deep relaxation in which change becomes possible.",
        sections: [
          {
            h: "What is hypnosis?",
            paras: [
              "Hypnosis is an altered state of consciousness between waking and sleeping. You know the feeling: when you are so absorbed in a book that you forget everything around you.",
              "About 90 percent of people can enter trance to a sufficient degree. And important: you remain in full control throughout the entire session.",
            ],
          },
          {
            h: "Scientifically recognised",
            paras: [
              "Hypnotherapy was recognised in 2006 by the German Scientific Advisory Board for Psychotherapy as an evidence-based psychotherapeutic method. In trance, breathing and the cardiovascular system calm down and stress hormone levels drop.",
              "I work with techniques by G. A. Estabrooks, Milton Erickson and Dave Elman.",
            ],
          },
          {
            h: "How a treatment unfolds",
            paras: [
              "We start with a free phone consultation. In the first session (approx. 2–3 hours) we conduct a detailed anamnesis interview. The actual trance work usually begins from the follow-up session.",
            ],
          },
        ],
      },
      havening: {
        title: "Havening",
        teaser:
          "Gentle touch, deep effect: one of the most modern methods for resolving trauma, anxiety and blocks.",
        sections: [
          {
            h: "What is Havening?",
            paras: [
              "Havening – from the English 'haven': harbour, refuge – was developed by the American physician and neuroscientist Dr. Ronald Ruden. It belongs to the psychosensory methods: several sensory stimuli are combined to positively influence the psyche.",
              "The so-called 'Havening Touch' – even, stroking touches on the face, palms and arms – demonstrably and lastingly calms the nervous system.",
            ],
          },
          {
            h: "How does it work?",
            paras: [
              "During treatment, the brain frequency shifts into the delta wave range – the frequency associated with deep sleep, cell regeneration and healing processes. Perceived stress drops astonishingly fast.",
              "To make the effect visible, you rate your burden at the beginning and end yourself on a scale of 0 to 10 (SUD value). Drops from 9 to 5–6 are not uncommon.",
            ],
          },
          {
            h: "For whom and how long?",
            paras: [
              "Havening is my central method for resolving trauma, anxiety states and blocks. Usually no more than 4–5 sessions are needed. Once the root of the problem has been found, the relief lasts permanently.",
            ],
          },
        ],
      },
      gespraechstherapie: {
        title: "Client-Centred Talk Therapy",
        teaser:
          "You are at the centre – not your problem. Based on Carl R. Rogers' person-centred approach.",
        sections: [
          {
            h: "The basic attitude",
            paras: [
              "This method is based on Carl R. Rogers' person-centred approach: positive appreciation, freedom from prejudice and genuine encounter at eye level.",
              "The focus is on you as a person – not on the problem. In this protected space you find your own answers.",
            ],
          },
          {
            h: "What it carries",
            paras: [
              "Talk therapy is the supporting relationship base of all my work – it accompanies every other method and creates the trust that makes change possible in the first place.",
            ],
          },
        ],
      },
      kultursensibel: {
        title: "Culturally Sensitive Therapy & Counselling",
        teaser:
          "Your story, your culture, your language: therapy that understands and respects your background.",
        sections: [
          {
            h: "What does culturally sensitive mean?",
            paras: [
              "Migration shapes mental health – through loss of home, language barriers, discrimination or the balancing act between two cultures. In culturally sensitive therapy, these experiences actively flow into the treatment.",
            ],
          },
          {
            h: "Needs-oriented instead of standard",
            paras: [
              "The goal is a treatment that truly fits you – your values, your family, your world. I offer sessions in German and Turkish.",
            ],
          },
        ],
      },
      thetahealing: {
        title: "ThetaHealing®",
        teaser:
          "Recognising and transforming blocking beliefs – an energetic method for body, mind and soul.",
        sections: [
          {
            h: "What is ThetaHealing?",
            paras: [
              "ThetaHealing is an energetic training and meditation method. It works with the deep beliefs that drive us – often since early childhood: 'I am not good enough', 'I must not fail'.",
            ],
          },
          {
            h: "The goal",
            paras: [
              "Blocks and fears are released by finding old beliefs and replacing them with strengthening ones. This activates the self-healing powers of body, mind and soul.",
            ],
          },
        ],
      },
      beratung: {
        title: "Psychological Counselling",
        teaser:
          "When life rearranges itself: clarity and orientation in times of transition.",
        sections: [
          {
            h: "When counselling helps",
            paras: [
              "Life circumstances change – and sometimes a new order is needed. Psychological counselling supports with dissatisfaction, anxieties, insecurity, sadness and decision blocks.",
            ],
          },
          {
            h: "Typical concerns",
            paras: [
              "An unfulfilled partnership, professional problems, persistent stress, smoking or overweight: in counselling we look together at what you need – and which path is the right one. Therapy treats issues with clinical significance; coaching and counselling strengthen your personality and life design.",
            ],
          },
        ],
      },
      coaching: {
        title: "Intensive Coaching",
        teaser:
          "For those who need clarity quickly: focused coaching for relationships, career and entrenched patterns.",
        sections: [
          {
            h: "What is intensive coaching for?",
            paras: [
              "Some questions do not need long therapy but concentrated clarity: conflicts in family or friendships, professional reorientation, the step into self-employment.",
            ],
          },
          {
            h: "The benefit",
            paras: [
              "We release entrenched thought and behaviour patterns and develop concrete solutions for your situation – focused, practical and aligned with your goals.",
            ],
          },
        ],
      },
      lebensstil: {
        title: "Individual Psychological Lifestyle Counselling",
        teaser:
          "According to Alfred Adler: understand what drives you – and change behaviour patterns deliberately.",
        sections: [
          {
            h: "The approach",
            paras: [
              "Alfred Adler's individual psychology sees the person as a whole: formative experiences shape our 'lifestyle' – the way we think, feel and act.",
            ],
          },
          {
            h: "Fields of application",
            paras: [
              "Personality counselling, conflict counselling, making decisions, creating clarity, understanding and changing behaviour patterns – and very practically: parenting counselling for parents.",
            ],
          },
        ],
      },
    },
  },
  pricing: {
    pageOverline: "Transparent & fair",
    pageTitle: "Fees",
    pageSub:
      "You know from the start what a session costs. All prices incl. 19% VAT.",
    items: [
      {
        name: "Initial consultation (phone)",
        duration: "30 min.",
        price: "Free",
        highlight: true,
        note: "Getting to know each other and clarifying your concern – no obligation",
      },
      {
        name: "Counselling & hypnosis coaching",
        duration: "60 min.",
        price: "340 €",
        note: "Individual session with a tailored method mix",
      },
      {
        name: "Couples coaching / family coaching with children",
        duration: "60 min.",
        price: "390 €",
        note: "For couples and families with children",
      },
      {
        name: "Suggestive weight reduction with hypnosis",
        duration: "60 min.",
        price: "340 €",
        note: "Anchoring healthy eating habits in the subconscious",
      },
      {
        name: "Smoke-free with hypnosis (intensive session)",
        duration: "120–180 min.",
        price: "999 €",
        note: "One-time intensive session with a high success rate",
      },
      {
        name: "Weekend & holiday surcharge",
        duration: "per 60 min.",
        price: "50 €",
        note: "Surcharge for appointments on weekends or public holidays",
      },
    ],
    notes: [
      "All prices incl. 19% VAT.",
      "Packages for clients travelling long distances: price on request.",
      "Payment in cash at the beginning of the session. Self-payers only.",
      "Private health insurance usually covers the costs.",
    ],
  },
  faq: {
    pageOverline: "Good to know",
    pageTitle: "Frequently asked questions",
    pageSub: "The most sought-after answers – short and understandable.",
    items: [
      {
        q: "What is the difference between therapy and coaching?",
        a: "Therapy treats issues with clinical significance – such as anxiety disorders, depression or trauma. Coaching and counselling serve personal development and topics without clinical significance, for example weight, stress management, smoking cessation or birth preparation.",
      },
      {
        q: "Is hypnosis safe?",
        a: "Yes. Hypnosis is a natural state of deep relaxation. You remain in full control throughout the session and can end the trance at any time. Hypnotherapy has been scientifically recognised in Germany since 2006.",
      },
      {
        q: "What does a trance feel like?",
        a: "Everyone experiences trance differently. Many describe it as pleasant, deep relaxation – comparable to being completely absorbed in a book or a film. You hear everything and can respond at any time.",
      },
      {
        q: "Does the effect last?",
        a: "Yes, because the changes are anchored in the subconscious – where habits and patterns arise. Once the cause has been resolved, the relief usually remains permanent.",
      },
      {
        q: "What issues does hypnosis help with?",
        a: "The field is wide: phobias, stress reduction, relaxation, sleep disorders, smoking cessation, weight, performance enhancement, exam anxiety, sports hypnosis, grief and heartbreak, relationship problems, allergies, self-confidence, medical hypnosis, children's hypnosis, dream journeys, Time Line and regression.",
      },
      {
        q: "How many sessions will I need?",
        a: "It depends on the topic. Smoking cessation often succeeds in a single intensive session. For anxiety or trauma, a few sessions are often enough – Havening usually requires 4–5 appointments. In the free initial call I give you an honest assessment.",
      },
      {
        q: "Are there online sessions?",
        a: "Yes, I offer many sessions online as well – conveniently from home, with the same care as in the practice.",
      },
      {
        q: "Does health insurance cover the costs?",
        a: "My practice is a self-pay practice. Private health insurance usually covers the costs – please clarify this with your insurer in advance.",
      },
    ],
  },
  about: {
    pageOverline: "About me",
    pageTitle: "Naciye Rafiq-Arli",
    pageSub: "Heilpraktikerin for psychotherapy – with experience, expertise and heart.",
    intro:
      "I am Naciye Rafiq-Arli, born in Hamburg, mother of four children, PTA with pharmaceutical training and state-certified alternative practitioner for psychotherapy. My focus lies on hypnosis, talk therapy and pastoral accompaniment. I support people holistically – empathetically, culturally sensitively and solution-oriented.",
    facts: [
      { label: "Born", value: "1976 in Hamburg" },
      { label: "Qualification", value: "Heilpraktikerin for Psychotherapy" },
      { label: "Training", value: "PTA / pharmaceutical field, studies in hypnosis" },
      { label: "Family", value: "Mother of four children" },
      { label: "Commitment", value: "Founding member of Rahmet e.V. – Muslim pastoral care Hamburg" },
      { label: "Languages", value: "German · Turkish" },
    ],
    approach: {
      title: "My therapeutic approach",
      text: "I work integratively with hypnosis, EFT, Havening and psychotherapeutic methods. Hypnotherapy uses the natural trance state to work through inner processes in a targeted way. EFT and Havening help to gently release emotional blocks. This is complemented by empathetic, client-centred conversation for lasting change and inner stability.",
    },
    engagement: {
      title: "My commitment",
      text: "As a founding member of Rahmet e.V. I am committed to Muslim pastoral care in Hamburg – with experience, expertise and heart.",
    },
    press: {
      title: "Press & Media",
      sub: "Featured in newspaper and radio – a selection of media appearances.",
      articleLabel: "Newspaper article",
      radioLabel: "Radio interview",
      viewCta: "View",
    },
    gallery: {
      title: "A look inside the practice",
      alts: {
        room: "Bright, quiet therapy room with armchair under a sloping roof",
        hafencity: "Naciye Rafiq-Arli in front of Hamburg's HafenCity",
        certificates: "The practice's certificate wall",
      },
    },
    helpList: {
      title: "Here is how I can help you",
      items: [
        "Anxieties & blocks: phobias, compulsion, depression, trauma",
        "Stress & exhaustion: burnout, inner restlessness, sleeplessness",
        "Self-development: self-confidence, finding goals, life crises",
        "Behaviour change: quitting smoking, weight reduction",
        "Women's topics & family: desire for children, birth, relationship, parenting",
      ],
    },
  },
  contact: {
    pageOverline: "Contact",
    pageTitle: "Let's talk about your concern",
    pageSub:
      "The easiest way: send me a message on WhatsApp. I will get back to you promptly.",
    whatsappTitle: "WhatsApp – direct & uncomplicated",
    whatsappText:
      "One click opens the chat with a prepared message – you only need to tap 'Send'.",
    whatsappPreviewLabel: "Your message to me:",
    phoneTitle: "Phone",
    emailTitle: "Email",
    addressTitle: "Practice",
    addressNote: "Hamburg-Alsterdorf – easy to reach by bus & train, parking nearby.",
    onlineTitle: "Online sessions",
    onlineText:
      "No need to travel to Hamburg: I offer many sessions online as well – with the same care and effect.",
    socialTitle: "Follow me",
  },
  footer: {
    tagline: "Practice for Hypnosis & Psychotherapy in Hamburg-Alsterdorf.",
    navTitle: "Navigation",
    contactTitle: "Contact",
    legalTitle: "Legal",
    imprint: "Imprint",
    privacy: "Privacy",
    copyright: "© 2026 Naciye Rafiq-Arli. All rights reserved.",
  },
  feedback: {
    pageOverline: "Trust through experience",
    pageTitle: "Feedback & Reviews",
    pageSub:
      "Client voices from various sources – so you can get an honest picture.",
    sourcesTitle: "Reviews at a glance",
    googleCta: "View on Google",
    jamedaCta: "View on Jameda",
    jamedaCount: "11 patient feedbacks",
    reportsCta: "Go to the reports",
    reportsCount: "6 detailed reports in full",
    shortTitle: "Testimonials",
    reportsTitle: "Experience reports in full",
    reportsNote: "These experience reports are shown in the original German.",
    fromLabel: "Experience report by",
    sourceLabel: "Source",
    sourceWebsite: "hypnosecoachinghamburg.com",
  },
  cookie: {
    title: "Cookies & Privacy",
    text: "We use cookies and similar technologies to optimise our website and analyse usage. You decide which cookies to allow. Details can be found in our privacy policy.",
    acceptAll: "Accept all",
    essentialOnly: "Essential only",
  },
  legal: {
    imprintTitle: "Imprint",
    imprintBlocks: [
      {
        h: "Information according to § 5 TMG",
        paras: [
          "Naciye Rafiq-Arli, Heilpraktikerin for Psychotherapy\nTraute-Lafrenz-Straße 161\n22297 Hamburg, Germany",
        ],
      },
      {
        h: "Contact",
        paras: ["Phone: +49 176 41 800 480\nEmail: n.rafiq-arli@web.de"],
      },
      {
        h: "Professional title",
        paras: [
          "Heilpraktikerin for Psychotherapy (granted in Germany). Responsible authority: Hamburg Public Health Office.",
        ],
      },
    ],
    privacyTitle: "Privacy Policy",
    privacyBlocks: [
      {
        h: "1. Responsible party",
        paras: [
          "Naciye Rafiq-Arli, Traute-Lafrenz-Straße 161, 22297 Hamburg, Germany, Email: n.rafiq-arli@web.de",
        ],
      },
      {
        h: "2. Collection and storage of personal data",
        paras: [
          "This website does not collect or store personal data via forms. When you contact me by email, phone or WhatsApp, your details are used exclusively to process your enquiry and are not passed on to third parties.",
        ],
      },
      {
        h: "3. WhatsApp",
        paras: [
          "When using the WhatsApp link you leave this website. The privacy policy of WhatsApp (Meta Platforms, Inc.) applies.",
        ],
      },
      {
        h: "4. Your rights",
        paras: [
          "You have the right at any time to information, correction and deletion of your stored data. Simply contact the address above.",
        ],
      },
    ],
  },
};

export default en;
